import { defaultSerializeQueryArgs } from '@reduxjs/toolkit/query/react';

export const serializeQueryArgs = ({ queryArgs, endpointName }) => {
  const { apiManager, ...rest } = queryArgs;

  return defaultSerializeQueryArgs({ endpointName, queryArgs: rest });
};
